import React, { useContext, useState } from 'react';
import { FormContext } from '@glu/validation-react';
import PropTypes from 'prop-types';
import Input from '../../gluValidation/Input';

export default function WireInput({ labelText, maxLength, name, readOnly, ...props }) {
  const { data } = useContext(FormContext);
  // using defaultValue because for some fields didn't set a value in memo
  const [memo, setMemo] = useState(data[name] || props.defaultValue || '');

  return (
    <Input
      debounceInput
      label={labelText}
      readOnly={readOnly}
      name={name}
      realTimeData={(event) => {
        const value = event?.target?.value || '';
        setMemo(value);
      }}
      charCount={!readOnly && maxLength ? `${memo.length}/${maxLength}` : ''}
      {...props}
    />
  );
}

WireInput.propTypes = {
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  readOnly: PropTypes.bool,
  labelText: PropTypes.string,
  maxLength: PropTypes.number,
  name: PropTypes.string.isRequired
};

WireInput.defaultProps = {
  defaultValue: '',
  readOnly: false,
  labelText: '',
  maxLength: 0
};
